import { UserMissingProfileInfoReturn } from 'helpers/userHelpers';
import * as yup from 'yup';
import { addressValidation } from '@alluradirect/react';

export function generateMissingInfoSchema(missingInfo: UserMissingProfileInfoReturn): any {
  const { missingAddressInformation, missingDateOfBirth, missingLastOrFirstName, missingPhone } = missingInfo;

  const baseSchema = yup.object().shape({
    DOB: yup.object().shape({
      YEAR: (() => {
        let validation = yup.string();
        if (missingDateOfBirth) {
          validation = yup.string().min(2).required().label('Year');
        }
        return validation;
      })(),
      MONTH: (() => {
        let validation = yup.string();
        if (missingDateOfBirth) {
          validation = yup.string().min(1).required().label('Month');
        }
        return validation;
      })(),
      DAY: (() => {
        let validation = yup.string();
        if (missingDateOfBirth) {
          validation = yup.string().min(1).required().label('Day');
        }
        return validation;
      })(),
    }),
    FIRST_NAME: (() => {
      let validation = yup.string();
      if (missingLastOrFirstName) {
        validation = yup.string().min(2).required().label('First Name');
      }
      return validation;
    })(),
    LAST_NAME: (() => {
      let validation = yup.string();
      if (missingLastOrFirstName) {
        validation = yup.string().min(2).required().label('Last Name');
      }
      return validation;
    })(),
    PHONE: (() => {
      let validation = yup.string();
      if (missingPhone) {
        validation = yup.string().min(3).required().label('Phone');
      }
      return validation;
    })(),
    IS_SMS_VERIFIED: (() => {
      let validation = yup.boolean();
      if (missingPhone) {
        validation = yup.boolean().isTrue('You must verify your phone number').required('You must verify your phone nuber').label('Phone Verified');
      }
      return validation;
    })(),
    ADDRESS: (() => {
      let validation = yup.object();
      if (missingAddressInformation) {
        validation = yup.object().shape(addressValidation);
      }
      return validation;
    })(),
  });

  return baseSchema;
}
